import type { ReactElement } from 'react'
import { useIntl } from 'react-intl'
import LandingPageLoyaltyBenefitTile from './LandingPageLoyaltyBenefitTile'
import { LOUNGE_PASSES_PAGE } from 'loyalty/constants/loyaltyRoutes'
import { useAppSelector } from 'hooks/reduxHooks'
import getLoyaltyIsInfiniteAccountTier from 'loyalty/selectors/getLoyaltyIsInfiniteAccountTier'

interface Props {
  layout: 'tile' | 'row'
  benefitLabel: ReactElement
}

function LandingPageLoyaltyLoungePass(props: Props) {
  const { layout, benefitLabel } = props
  const intl = useIntl()
  const isInfinite = useAppSelector(getLoyaltyIsInfiniteAccountTier)

  const heading = isInfinite
    ? intl.formatMessage({
        id: '1YMuXnuNqQzuTl-P50Iz',
        defaultMessage: 'Infinite airport lounge passes',
        description: 'Heading for the airport lounge pass benefit tile shown to Infinite tier members',
      })
    : intl.formatMessage({
        id: 'c9p-4SjsKWKqzrAh-aoA',
        defaultMessage: 'Free airport lounge passes',
        description: 'Heading for loyalty airport lounge pass benefit tile',
      })

  return <LandingPageLoyaltyBenefitTile
    layout={layout}
    benefitType="lounge_pass"
    heading={heading}
    subtitle={benefitLabel}
    to={`/${LOUNGE_PASSES_PAGE}`}
  />
}

export default LandingPageLoyaltyLoungePass
